export function random(min: number, max: number) {
  min = Math.ceil(min)
  max = Math.floor(max)
  return Math.floor(Math.random() * (max - min + 1) + min)
}

export function createIds(prefix: string = "ac") {
  const date = new Date()
  const time = date.getTime()
  return `${prefix}-${time}-${random(1987, time)}-${random(2009, time)}`
}

export function createElement(html: string): ChildNode | null {
  const template = document.createElement("template")
  html = html.trim()
  template.innerHTML = html
  return template.content.firstChild
}

export function createElementIfNotExists(
  selector: string,
  html: string,
  appendTo = "body",
): Element | null {
  let el: Element | null = document.querySelector(selector)
  if (!el) {
    document.querySelector(appendTo)?.insertAdjacentHTML("afterbegin", html)
    el = document.querySelector(selector)
  }
  return el
}

export function nl2br(str, is_xhtml = false) {
  if (typeof str === "undefined" || str === null) {
    return ""
  }
  var breakTag = is_xhtml || typeof is_xhtml === "undefined" ? "<br />" : "<br>"
  return (str + "").replace(
    /([^>\r\n]?)(\r\n|\n\r|\r|\n)/g,
    "$1" + breakTag + "$2",
  )
}

export function chunk(array: Array<any>, size: number) {
  const chunked_arr = []
  let index = 0
  while (index < array.length) {
    chunked_arr.push(array.slice(index, size + index))
    index += size
  }
  return chunked_arr
}

export function debounce(fn: any, wait: number) {
  let timer: ReturnType<typeof setTimeout>
  if (timer) clearTimeout(timer)
  timer = setTimeout(() => {
    if (typeof fn === "function") {
      fn()
    }
  }, wait)
}

export function datesDiff(date1: Date, date2: Date) {
  let diff = Math.abs(date1.getTime() - date2.getTime()) / 1000
  const periods = {
    years: 31556926,
    months: 2629743,
    weeks: 604800,
    days: 86400,
    hours: 3600,
    minutes: 60,
    seconds: 1,
  }
  const out = []
  for (let name in periods) {
    const value = Math.floor(diff / periods[name])
    if (value > 0) {
      diff = diff % periods[name]
      out.push(`${value} ${name}`)
    }
  }
  return out.join(", ")
}

export function formatBytes(bytes, decimals = 2) {
  if (bytes === 0) return "0 Bytes"

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
}

export const na = () => {
  return `<span class="text-muted">N/A</span>`
}

export function placeCaretAtEnd(el) {
  el.focus()
  const body: any = document.body
  if (
    typeof window.getSelection != "undefined" &&
    typeof document.createRange != "undefined"
  ) {
    var range = document.createRange()
    range.selectNodeContents(el)
    range.collapse(false)
    var sel = window.getSelection()
    sel.removeAllRanges()
    sel.addRange(range)
  } else if (typeof body.createTextRange != "undefined") {
    var textRange = body.createTextRange()
    textRange.moveToElementText(el)
    textRange.collapse(false)
    textRange.select()
  }
}

export function copyText(text): Promise<void> {
  if (window.isSecureContext) {
    return navigator.clipboard.writeText(dedent(text))
  }
  return new Promise<void>((_, reject) => {
    reject()
  })
}

export function dedent(text) {
  const format = (str) => {
    const lines = str.split("\n")
    let out = ""
    lines.forEach((line) => {
      out += `${line.trim().replace(/ +(?= )/g, "")}\n`
    })
    return out
  }

  return format(text)
}
